import cookie from "js-cookie"

export const setCookie = (key, value) => {
	if (window !== "undefined") {
		cookie.set(key, value, {
			secure: true,
			sameSite: 'lax'
		})
	}
}

export const removeCookie = (key) => {
	if (window !== "undefined") {
		cookie.remove(key, {
			expires: 1
		})
	}
}

export const getCookie = (key) => {
	if (window !== "undefined") {
		return cookie.get(key)
	}
}

export const setLocalStorage = (key, value) => {
	if (window !== "undefined") {
		localStorage.setItem(key, JSON.stringify(value))
	}
}

export const removeLocalStorage = (key) => {
	if (window !== "undefined") {
		localStorage.removeItem(key)
	}
}

// User cookie helpers: store `user` in cookie with sameSite flag
export const setUser = (value) => {
    if (window !== "undefined") {
        try {
            cookie.set("user", JSON.stringify(value), {
                secure: true,
                sameSite: 'lax'
            })
        } catch (e) {
            console.error("setUser error:", e)
        }
    }
}

export const getUser = () => {
    if (window !== "undefined") {
        const raw = cookie.get("user")
        if (!raw) return null
        try {
            return JSON.parse(raw)
        } catch (e) {
            console.error("getUser decode error:", e)
            return null
        }
    }
}

export const removeUser = () => {
    if (window !== "undefined") {
        cookie.remove("user")
    }
}

export const authenticate = (response, next) => {
	setUser(response.data.user)
	setLocalStorage("token", response.data.token)
	next()
}

export const signOut = (next) => {
	removeUser()
	removeLocalStorage("token")
}

export const isAuth = () => {
	if (window !== "undefined") {
		const user = getUser()
		const token = localStorage.getItem("token")
		if (user && token) {
			return user
		}
		return false
	}
}

export const updateUser = (response, next) => {
	console.log("UPDATE USER IN COOKIE HELPERS", response)
	if (typeof window !== "undefined") {
		const auth = response.data
		setUser(auth)
	}
	next()
}
